export const gameConstants = {
  SET_DATA: 'SET_GAME_DATA',
  ADD_PLAYERS: 'ADD_PLAYERS',
  SET_ROUND: 'SET_ROUND',
};

export const roleNames = ['Generex', 'Energetics'];
